import { FC, PropsWithChildren } from 'react';
import { RemountableErrorBoundary } from 'modules/error';
import { ErrorMessage } from './ErrorMessage';
import { DYNAMIC_CONTENT_RUM_ATTRIBUTES } from '../../constants';

export const DynamicContentBuilderErrorBoundary: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <RemountableErrorBoundary
      errorMarkup={({ remount, isRemounting }) => (
        <ErrorMessage refresh={remount} isRefreshing={isRemounting} />
      )}
      {...DYNAMIC_CONTENT_RUM_ATTRIBUTES}
    >
      {children}
    </RemountableErrorBoundary>
  );
};
